import React, { useContext, useState, createContext } from 'react'

type ModalTemplateType =
  | 'Staff'
  | 'GreentechPartner'
  | 'ImageGallery'
  | 'Search'
  | 'Video'
  | 'Production'
  | 'Region'
  | 'InspiredMember'
  | 'DataCenterBusiness'
  | 'CompanyAndRepresentative'

const ModalContext = createContext<{
  isOpen: boolean
  containerClass: string
  idx: number
  contentArray: any[]
  templateType: ModalTemplateType
  executeModal: (
    contentArray: any | any[],
    startIdx: number,
    cntClass: string,
    templateType: ModalTemplateType
  ) => void
  closeModal: () => void
  nextContent: () => void
  prevContent: () => void
}>({
  isOpen: false,
  containerClass: '',
  idx: 0,
  contentArray: [],
  templateType: 'Staff',
  executeModal() {},
  closeModal() {},
  nextContent() {},
  prevContent() {}
})

const ModalProvider: React.FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [contentArray, setContentArray] = useState<any[]>([])
  const [idx, setIdx] = useState<number>(0)
  const [containerClass, setContainerClass] = useState<string>('')
  const [templateType, setTemplateType] = useState<ModalTemplateType>('Staff')

  const executeModal = (contentArray: any[], startIdx = 0, cntClass: string, templateType: ModalTemplateType) => {
    setTemplateType(templateType)
    setContentArray(Array.isArray(contentArray) ? contentArray : [contentArray])
    setIdx(startIdx)
    setContainerClass(cntClass)
    setIsOpen(true)
  }

  const addIndex = (add: number) => {
    setIdx((idx + contentArray.length + add) % contentArray.length)
    window.location.hash = ((idx + contentArray.length + add) % contentArray.length).toString()
  }

  const nextContent = () => addIndex(1)
  const prevContent = () => addIndex(-1)

  const closeModal = () => {
    window.location.hash = ' '
    setIsOpen(false)
  }

  return (
    <ModalContext.Provider
      value={{
        isOpen,
        executeModal,
        contentArray,
        closeModal,
        containerClass,
        idx,
        nextContent,
        prevContent,
        templateType
      }}
    >
      {children}
    </ModalContext.Provider>
  )
}

const useModal = () => useContext(ModalContext)
export { ModalContext, ModalProvider, ModalTemplateType, useModal }
